import ServiceCRUD from '../../../services/ServiceCRUDFLEXUC';

class Service extends ServiceCRUD {
  constructor() {
    super('/api/contextos');
  }
}

export default new Service();
